import './faq.css'

const FAQ = () => {
  const faqData = [
    {
      question: "¿Qué es Unirmentes AI y cuál es su propósito?",
      answer: "Es un asistente de IA interactivo y conversacional centrado en brindar conocimientos, herramientas prácticas y detección temprana de síntomas de riesgo en cuatro áreas clave: Psicología, Finanzas, Derecho y Bienestar Laboral. Nuestro objetivo es la capacitación continua y la orientación oportuna basada en derechos y seguridad."
    },
    {
      question: "¿Qué me diferencia de otros servicios de IA?",
      answer: "Nuestro principal valor es la personalización profunda y la integración con expertos humanos. Adaptamos el contenido a su edad, país y ocupación, y dirigimos a los usuarios que requieran una atención especializada hacia nuestros profesionales expertos en https://www.unirmentes.com."
    },
    {
      question: "¿Unirmentes AI usa Modelos de IA de pago?",
      answer: "Sí. Utilizamos una orquestación de servicios de LLMs de pago como Google Gemini, Grok (xAI) y OpenAI (ChatGPT). Hemos configurado activamente estas plataformas para asegurar que sus conversaciones no sean utilizadas para entrenar los modelos de IA, garantizando su privacidad."
    },
    {
      question: "¿Cómo garantiza Unirmentes AI mi seguridad y privacidad?",
      answer: "Priorizamos la seguridad mediante cifrado de datos en tránsito y en reposo, anonimización y un Encargado del Tratamiento especializado. DIGITAL PSYCHOLOGY Solutions SAS no accede al contenido de sus conversaciones, y las configuraciones empresariales de los modelos de IA impiden que se usen para entrenamiento. Nuestras prácticas cumplen con la Ley 1581 (Colombia) y tienen como referencia estándares internacionales como ISO 27018."
    },
    {
      question: "¿El servicio sustituye a un profesional?",
      answer: "No. Unirmentes AI es una guía informativa y educativa. Si detectamos signos de alerta o la necesidad de una profundización, remitimos al usuario a la atención de nuestros profesionales especializados en Colombia o a líneas de crisis en el extranjero."
    },
    {
      question: "¿Qué tipo de contenidos ofrece?",
      answer: (
        <div className="content-list">
          <p><strong>Psicología:</strong> Manejo del estrés, ansiedad, resiliencia y bienestar emocional.</p>
          <p><strong>Finanzas:</strong> Fundamentos de ahorro, inversión y presupuesto, adaptados al contexto de su país.</p>
          <p><strong>Derecho:</strong> Derechos básicos, contratos, protección de datos y prevención de situaciones jurídicas adversas.</p>
          <p><strong>Bienestar Laboral:</strong> Recursos y orientación para el bienestar en el entorno laboral.</p>
        </div>
      )
    }
  ];

  return (
    <>
      <header className="page-header faq-header">
        <h1>PREGUNTAS FRECUENTES (FAQ)</h1>
      </header>
      <section className='page-content faq-content'>
        <div className="faq-container">
          {faqData.map((item, index) => (
            <div key={index} className="faq-item">
              <h3 className="faq-question">{item.question}</h3>
              <div className="faq-answer">
                {typeof item.answer === 'string' ? <p>{item.answer}</p> : item.answer}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  )
}

export default FAQ

